import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import services from "../services/services";
import { decryptData, encryptData } from "../utils/encrypt";
import { config, Urls } from "../services/Urls";
import { callautopopulate } from "../services/callautopop";

const useAuthStore = create(
    devtools(
        (set, get) => ({
            loginSuccess: false,
            myPermission: [],
            noPermission: false,
            setLoginSuccess: (value) => set({ loginSuccess: value }),
            setPermission: (permissions) => set({ myPermission: permissions }),
            setNopermission: (value) => set({ noPermission: value }),
            getMyPermissions: async (key) => {
                const { setLoginSuccess, setPermission, setNopermission } = get();
                let autoUsercode;
                try {
                    const res = await callautopopulate("user_info");
                    autoUsercode = res?.user_info?.[0];

                    if (autoUsercode?.user_code) {
                        config.setUserCode(autoUsercode.user_code);
                        sessionStorage.setItem("user_code", encryptData(`${autoUsercode.user_code}`));
                    }
                    const userCode = decryptData(sessionStorage.getItem("user_code"));

                    const response = await services.getInvokeRemote('GET', Urls('GETMYPERMISSION', parseInt(userCode)));
                    if (response?.body?.data?.myPermission?.length > 0) {
                        setPermission(response.body.data.myPermission);
                    } else {
                        setNopermission(true);
                    }
                    setLoginSuccess(true);
                } catch (err) {
                    setLoginSuccess(false);
                    sessionStorage.clear();
                    window.location.href = "/sign-in";
                    console.error(err);
                    if (key === "login") {
                        throw new Error(err);
                    }
                }
            }
        }),
        { name: 'auth-store' }
    )
);

export default useAuthStore;
